<template>
    <div class="container container-fluid">
        <h2>Δημιουργία ομάδας</h2>
        <div class="card">
            <div class="card-body">
                <CreateTeam ref="team"/>
                <br>
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <button id="finalize" class="btn btn-success" v-on:click="createGroup">Αποθήκευση</button>
                        <br>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CreateTeam from '../components/teams/CreateTeam';

export default {
    name: "CreateTeamView",
    components: {CreateTeam},
    data() {
        return {}
    },
    created() {
        if (this.$store.getters.userRole !== "ROLE_MANAGER" && (this.$store.getters.userRole !== "ROLE_SXHMATISMOS"))  this.$router.push('home');
    },
    methods: {
        createGroup() {
            this.$refs.team.createGroup();
        }
    }
}
</script>

<style scoped>

</style>